import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import createHistory from 'history/createBrowserHistory';
import App from './App';
import { MyPageTheme } from './amplifyTheme.js';

const history = createHistory();

// const isProd = STACK_NAME === 'prod';
// ReactGA.initialize('UA-7771011-20', { debug: !isProd });
// const registerGaPageview = path => {
//   ReactGA.set({ page: path });
//   ReactGA.pageview(path);
// };
// registerGaPageview(window.location.pathname);
// history.listen(location => {
//   registerGaPageview(location.pathname);
// });

ReactDOM.render(
  <App theme={MyPageTheme} history={history} />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js